<template>
  <v-card
    loader-height="8"
    :loading="admin.projectSettingsLoading"
    :disabled="admin.projectSettingsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Project Settings
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="projectSettingHeaders"
        :items="admin.projectSettingList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.projectSettingList.length == 0"
        :hide-default-header="admin.projectSettingList.length == 0"
      >
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeName(item.attributeId) }}
        </template>
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProjectSetting"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    data() {
      return {
        projectSettingHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'LABEL', value: 'label' },
          { text: 'CONTROL TYPE', value: 'controlType' },
          { text: 'VALUE SUFFIX', value: 'valueSuffix' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProjectSettingSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProjectSettingSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getProjectSettingList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given projectId
       */
      getAttributeName(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Project Attribute to currently selected project
       */
      addNewProjectSetting() {
        this.$store.commit('admin/setSelectedProjectSetting', {
          id: 'new',
          attributeId: 0,
          label: '',
          controlType: '',
          valueSuffix: '',
          published: false
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedProjectSetting', data.item);
        } else {
          this.$store.commit('admin/setSelectedProjectSetting', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this projects selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProjectSettingSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
